import { Controller } from "@hotwired/stimulus";

// Toggles the Email / Share link / QR panels in the invite flyout without a server
// round-trip. Tabs and panels are paired by a matching `data-tab` value.
//
//   <div data-controller="invite-tabs">
//     <button data-invite-tabs-target="tab" data-tab="email" data-action="invite-tabs#select">…</button>
//     <div data-invite-tabs-target="panel" data-tab="email">…</div>
//   </div>
export default class extends Controller {
  static targets = ["tab", "panel"];

  declare readonly tabTargets: HTMLElement[];
  declare readonly panelTargets: HTMLElement[];

  select(event: Event) {
    const selected = (event.currentTarget as HTMLElement).dataset.tab;

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === selected;
      tab.classList.toggle("tab-active", active);
      tab.setAttribute("aria-selected", String(active));
    });

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tab !== selected;
    });
  }
}
